import texts from "../locale";

export const getLanguage = (key) => {
  return key.split(".").reduce((o, i) => (o ? o[i] : key), texts);
};
